import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CircularProgress, IconButton, Stack, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { BlacklistSearchResponse } from "./types";
import NewResultList from "./NewResultList";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default function NewBlackListNameSearch() {
  const query = useQuery();
  const urlName = query.get("name");
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [score, setScore] = useState("80");
  const [nameError, setNameError] = useState(false);
  const [results, setResults] = useState<BlacklistSearchResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [noResults, setNoResults] = useState(false);

  useEffect(() => {
    if (urlName) {
      setName(urlName);
      onSubmit(urlName);
    }
  }, [urlName]);

  const onSubmit = async (passedInName: string) => {
    if (!passedInName) {
      setNameError(true);
      return;
    }
    setLoading(true);
    const { data } = await axios.get<BlacklistSearchResponse[]>("/api/blacklist/searchNewName", {
      params: { name: passedInName, score }
    });
    setResults(data);
    setNoResults(data.length === 0);
    setLoading(false);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(name);
        }}
      >
        <Stack direction="row">
          <div style={{ display: "flex", gap: 8 }}>
            <TextField
              error={nameError}
              label="Search Name"
              value={name}
              onChange={(e) => {
                const newName = e.target.value;
                setName(newName);
                setNameError(false);
                setNoResults(false);
                if (debounceRef.current) clearTimeout(debounceRef.current);
                debounceRef.current = setTimeout(() => {
                  navigate(`?name=${encodeURIComponent(newName)}`, { replace: true });
                }, 400);
              }}
              helperText={nameError ? <div style={{ color: "red" }}>Please Enter a Name</div> : ""}
            />
            <TextField
              type="number"
              label="Threshold"
              value={score}
              onChange={(e) => {
                setScore(e.target.value);
              }}
            />
            <IconButton type="submit" color="primary">
              {loading ? <CircularProgress size={24} /> : <Search />}
            </IconButton>
          </div>
        </Stack>
      </form>
      <div style={{ marginTop: 16 }}>
        {results.length > 0 && <NewResultList data={results} />}
        {noResults && <div>No results found for {name}</div>}
      </div>
    </>
  );
}
